import React from "react";
import OndeffModal from "./OndeffModal";

export default class BlogPost extends React.Component 
{
    constructor(props)
    {
        super(props)
        this.post = this.props.post
        this.childRef = React.createRef();
        this.state = {
            ondeffCode: 'priceAndAvailabilityForm',
            isVertical: undefined
        }
    }

    componentDidMount() {
        this.attachEventListeners();
    }

    componentDidUpdate() {
        this.attachEventListeners();
    }

    attachEventListeners = () => {
        const buttons = document.querySelectorAll(".open-ondeff-modal");
        buttons.forEach((button) => {
            if (!button.dataset.listenerAdded) { // Prevent duplicate listeners
                button.dataset.listenerAdded = "true";

                button.addEventListener("click", () => {
                    const buttonId = button.id;
                    this.setState({ ondeffCode: buttonId }, () => {
                        if (this.childRef.current) {
                            this.childRef.current.triggerChangeShowModal();
                        }
                    });
                });
            }
        });
    };

    getImage = (image) =>
    {
        if(image === null)
        {
            return(<></>)
        }

        const alt = image.alt !== '' ? image.alt : 'hometown';
        
        return(
            <div className="main-image">
                <img src={image.path} alt={alt} loading="lazy"/>
            </div>
        )
    }
    getVideo = (video) =>
        {
            if (video === null) {
                return <></>
            }

          // get the video id from the URL
            let videoId = video.split("v=")[1]
            if (!videoId) {
                videoId = video.split("/embed/")[1]
            }

            // IMPORTANT: this is the mobile version of the video thumbnail, "oardefault.jpg" only response when the video is vertical
            // for horizontal videos, the response is width > height
            const mobileURL = `https://img.youtube.com/vi/${videoId}/oardefault.jpg`

            if (typeof window !== 'undefined' && this.state.isVertical === undefined) {
                const img = new Image()
                img.src = mobileURL
                // detect if the video is vertical or horizontal, using the image thumbnail dimensions. For horizontal videos, the response (404) is width > height
                img.onload = () =>
                    img.width > img.height
                    ? this.setState({ isVertical: false })
                    : this.setState({ isVertical: true })
            }


            return (
                <div
                    className={`main-image ${
                    this.state.isVertical ? "vertical" : null
                    }`}
                >
                    <iframe
                    src={video}
                    style={{ marginBottom: "0px" }}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    />
                </div>
            )
        }


    getUpdatedDate = (date) => {
        if(!date) return (<></>)
        const formatedDate = new Date(date)
        return 'Updated ' + formatedDate.toLocaleDateString('en-us', { day:"numeric", year:"numeric", month:"long"})
    }
    
    getTxt = (text) =>
    {
        let txt = text       
        txt = txt.replace(/<table/g, "<div style='overflow:auto;'><table")    
        txt = txt.replace(/\/table>/g, "\/table></div>") 
        txt = txt.replace(/<img/g, "<img loading='lazy'")
        return txt
    }


    render() 
    {    
        return (
            <div className="post">  
                {this.post.media_type === 'video' ? this.getVideo(this.post.video) : this.getImage(this.post.image)}
                <ul className="tags">
                {                
                    this.post.tags.map(tag =>
                    {                        
                        return (
                            tag.id !== 'success' ? (
                            <li class="big"><a href={'/blog/tags/'+tag.slug}>{tag.name}</a></li>
                            ) : (
                            <li class="big"><a href={'/pro/guide/tags/'+tag.slug}>{tag.name}</a></li>
                            )
                        )
                    })
                }
                </ul>
                <p className="changedDate">{this.getUpdatedDate(this.post.changed)}</p>
                <div className="body" dangerouslySetInnerHTML={{__html: this.getTxt(this.post.content)}}></div>
                <OndeffModal
                    ondeffCode={this.state.ondeffCode}
                    ref={this.childRef}
                />
            </div>   
        )
    }
};